"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deflateCoordinate = deflateCoordinate;
exports.deflateCoordinates = deflateCoordinates;
exports.deflateCoordinatesArray = deflateCoordinatesArray;
exports.deflateMultiCoordinatesArray = deflateMultiCoordinatesArray;

/**
 * @module ol/geom/flat/deflate
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */
function deflateCoordinate(flatCoordinates, offset, coordinate, stride) {
  for (var i = 0, ii = coordinate.length; i < ii; ++i) {
    flatCoordinates[offset++] = coordinate[i];
  }

  return offset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<import("../../coordinate.js").Coordinate>} coordinates Coordinates.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */


function deflateCoordinates(flatCoordinates, offset, coordinates, stride) {
  for (var i = 0, ii = coordinates.length; i < ii; ++i) {
    var coordinate = coordinates[i];

    for (var j = 0; j < stride; ++j) {
      flatCoordinates[offset++] = coordinate[j];
    }
  }

  return offset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<import("../../coordinate.js").Coordinate>>} coordinatess Coordinatess.
 * @param {number} stride Stride.
 * @param {Array<number>} [opt_ends] Ends.
 * @return {Array<number>} Ends.
 */


function deflateCoordinatesArray(flatCoordinates, offset, coordinatess, stride, opt_ends) {
  var ends = opt_ends ? opt_ends : [];
  var i = 0;

  for (var j = 0, jj = coordinatess.length; j < jj; ++j) {
    var end = deflateCoordinates(flatCoordinates, offset, coordinatess[j], stride);
    ends[i++] = end;
    offset = end;
  }

  ends.length = i;
  return ends;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} coordinatesss Coordinatesss.
 * @param {number} stride Stride.
 * @param {Array<Array<number>>} [opt_endss] Endss.
 * @return {Array<Array<number>>} Endss.
 */


function deflateMultiCoordinatesArray(flatCoordinates, offset, coordinatesss, stride, opt_endss) {
  var endss = opt_endss ? opt_endss : [];
  var i = 0;

  for (var j = 0, jj = coordinatesss.length; j < jj; ++j) {
    var ends = deflateCoordinatesArray(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
    endss[i++] = ends;
    offset = ends[ends.length - 1];
  }

  endss.length = i;
  return endss;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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